const PrintMode = {
    View: 'view',
    Print: 'print'    
};
export default PrintMode;